module.exports = __webpack_public_path__ + "img/25200.1f95e3bf.jpg";